window.currencySymbol = '$'
let gwpES6 = true

window.API_VERSION = '2021-01'
window.API_ACCESS = '4003e104b00c45cb773f6285e0e1f40c'
 

class FostrGWP extends FostrCartItems { 
  constructor() {
    super({
      name: 'Fostr GWP',
      version: '1.0.0'
    })

    this.cartState = undefined
    this.items = []
    this.cartGWP = document.querySelector('fostr-cart-gwp')
    // this.previousTier = 0
    // this.currentTier = 0
    // this.nextTier = 0

    this.previousTiers = [];
    this.currentTiers = [];
    this.nextTiers = [];

    this.difference = 0
    this.price = 0
    this.addItems = []
    this.removeItems = {}
    this.gwpRemainingMsg = undefined
    this.checkGWPEligibilityCounter = 0
    this.gwpModalCloseCounterCookie = 'GWPCounter'
    this.gwpModalCloseCounter = 0
    this.gwpDisableModalCookie = 'GWPDisableModal'
    this.gwpDisableModalThreshold = 'GWPDisableModalThreshold'
    this.currentProductData = undefined
    this.minicart = document.querySelector('offcanvas-menu')
    this.sortedGWTPGifts = ''
    this.enableGWAP = !!gwpJSON.enableGWAP
    this.enableGWTP = !!gwpJSON.enableGWTP
    this.enableGWCP = !!gwpJSON.enableGWCP
    this.enableGWP = !!gwpJSON.enableGWP 
    this.gwpTypes = [
      {
        method: 'gwap',
        type: 'auto',
        enabled: this.enableGWAP
      },
      {
        method: 'gwtp',
        type: 'threshold',
        enabled: this.enableGWTP
      }, 
      {
        method: 'gwcp',
        type: 'collection',
        enabled: this.enableGWCP
      },
      {
        method: 'gwp_product',
        type: 'product',
        enabled: this.enableGWP
      },
      {
        method: 'gwp_collection',
        type: 'collec_prd',
        enabled: this.enableGWCP
      }
    ]

    this.init()
  }

  async init() {
    if (document.getElementsByClassName('checkoutForGwp')[0]) {
      document.getElementsByClassName('checkoutForGwp')[0].setAttribute("disabled", true);
    }
    console.log('GWPLOG:===========================================')
    console.log('GWPLOG:               run update')
    console.log('GWPLOG:===========================================')
    await this.updateCartData()

    this.gwtpNotifications()

  
    if (!Object.values(this.items).length >= 1) return

    console.log('GWPLOG:📓 checking number of calls')
    if (this.checkGWPEligibilityCounter >= 1) return
    this.checkGWPEligibility()

    document
      .querySelectorAll('[data-gwtp-message]')
      .forEach(
        el =>
          (el.innerText = el.dataset.gwtpMessage.replace(
            '[[ amount ]]',
            window.currencySymbol + el.dataset.gwtpThreshold
          ))
      )
    document
      .querySelectorAll('[data-gwcp-message]')
      .forEach(
        el =>
          (el.innerText = el.dataset.gwcpMessage.replace(
            '[[ collection ]]',
            el.dataset.gwcpCollection
          ))
      )

    //-----  Popoup Gift  
    if(gwpJSON.enable_choose_gift_threshold==true && gwpJSON.gift_popup_threshold <= this.price)
    {  
        if( gwpJSON.gifts.length > 0)
        {
          const existingGifts= this.checkGiftsInCart(); 
          if(existingGifts.length > 1)
          {
            for(let i=0; i<existingGifts.length ; i++)
            {
              this.removeItems = { ...this.removeItems, [existingGifts[i].key]: 0 }
            }
          } 
          if(existingGifts.length==0)
          {
            this.chooseGiftPopup();
          }
        }
    }
    if(gwpJSON.gift_popup_threshold > this.price)
    {
      const existingGifts= this.checkGiftsInCart(); 
     
        for(let i=0; i<existingGifts.length ; i++)
        {
          this.removeItems = { ...this.removeItems, [existingGifts[i].key]: 0 }
        }
       
    }
    //-----  end Popup Gift
      
   
    this.runGWP()

    
  }
   checkGiftsInCart() {

    const existingGiftsInCart = [];
    gwpJSON.gifts.forEach(gift => {
      let giftFoundInCart = false;
   
      for (const item of this.items) { 
        if (item.properties && item.properties._gwpType === "choose_gift" && item.id == gift.id) {
          giftFoundInCart = true;
          existingGiftsInCart.push(item);
          break; 
        }
      }
   
    });
    return existingGiftsInCart;
  } 
  chooseGiftPopup()
  {
   
      let existingModal = document.getElementById('giftModal');
      if (existingModal) {
        existingModal.remove();
      }
   
      const modal = document.createElement('div');
      modal.id = 'giftModal';
      modal.classList.add('gift-modal');
   
      const modalContent = document.createElement('div');
      modalContent.classList.add('gift-modal-content');
   
      const closeButton = document.createElement('span');
      closeButton.innerHTML = '&times;';
      closeButton.classList.add('close');
   
      closeButton.onclick = function () {
        document.body.removeChild(modal);
      };
   
      const giftOptions = document.createElement('div');
      giftOptions.classList.add('gifts_list_container');
      const popupTitle = document.createElement('h3');
      popupTitle.textContent=gwpJSON.choose_gift_title;
      popupTitle.style.cssText = `
      font-size: 24px;
      margin-bottom: 20px;
      margin-top: 20px;
      text-align: center;
      color: #333;
    `;
      popupTitle.style.textAlign="center";

      modalContent.appendChild(popupTitle)
      gwpJSON.gifts.forEach(gift => {
        const giftItem = document.createElement('div');
        giftItem.classList.add('gift_item');
        giftItem.setAttribute('data-variant-id', gift.id);
        giftItem.setAttribute('data-threshold', gift.threshold);
   
        const giftImage = document.createElement('img');
        giftImage.src = gift.image;
        giftImage.alt = gift.title; 
        const giftInfo = document.createElement('div');
        const giftTitle = document.createElement('h4');
        giftTitle.textContent = gift.title;  
        giftInfo.appendChild(giftTitle);
        // giftInfo.appendChild(giftThreshold); 
        const selectButton = document.createElement('button');
        selectButton.textContent = 'Add';
        selectButton.classList.add('gift_add_to_cart');
        selectButton.setAttribute('data-variant-id', gift.id); 
        giftItem.appendChild(giftImage);
        giftItem.appendChild(giftInfo);
        giftItem.appendChild(selectButton);
   
        giftOptions.appendChild(giftItem);
      }); 
      modalContent.appendChild(closeButton);
      modalContent.appendChild(giftOptions);
   
      modal.appendChild(modalContent);
   
      document.body.appendChild(modal);
    }
  
  

  loading(bool) {
    const minicart = document.getElementById('fostr-mini-cart-items')

    if (minicart) {
      let loadingOverlay = minicart.querySelector(':scope > .loading-overlay')
      if (!!bool) {
        console.log('GWPLOG:📓 loading...')
        if (loadingOverlay) {
          loadingOverlay.classList.remove('hidden')
        }
        minicart.style.overflow = 'hidden'
      } else {
        console.log('GWPLOG:📓 finished loading')
        if (loadingOverlay) {
          loadingOverlay.classList.add('hidden')
        }
        minicart.style.overflow = ''
      }
    }
  }

  async updateCartData() {
    const getCart = await fetch('/cart.js', { method: 'GET' })
    const cartState = await getCart.json()

    this.cartState = cartState 
    window.cartState = cartState
    this.price = this.cartState.total_price / 100
    this.items = new Proxy(cartState.items, {})

    this.sortedGWTPGifts = Object.values(gwpJSON.GWPGifts).sort(
      (a, b) => a.value - b.value
    );
    
   
    this.currentTiers = this.sortedGWTPGifts
    .filter(gift => gift.type === 'threshold' && this.price >= gift.value)
    .map(gift => parseInt(gift.value));
    
 
  this.currentTiers = this.currentTiers.length ? [Math.max(...this.currentTiers)] : [];

  console.log('currentTiers: ' + JSON.stringify(this.currentTiers));

   
    this.previousTiers = this.items
    .filter(item => item.properties?._gwpType === 'threshold')
    .map(item => parseInt(item.properties._gwpThreshold))
    .filter(tier => !this.currentTiers.includes(tier));
  
  console.log('previousTiers: ' + JSON.stringify(this.previousTiers));
 
  this.nextTiers = this.sortedGWTPGifts
    .filter(gift => gift.type === 'threshold' && this.price < gift.value)
    .map(gift => parseInt(gift.value));

    this.nextTiers = this.nextTiers.length ? [Math.max(...this.nextTiers)] : [];
  
  console.log('nextTiers: ' + JSON.stringify(this.nextTiers));
 
  this.difference = (
    !!this.nextTiers.length ? this.nextTiers[0] - this.price : 0
  ).toFixed(2);

  console.log('difference: ' + this.difference);
  }

  runGWP() {
    this.gwpTypes
      .filter(obj => obj.enabled)
      .forEach(enabledObj =>
        this[enabledObj.method](
          Object.values(gwpJSON.GWPGifts).filter(
            gift => gift.type === enabledObj.type
          ),
          enabledObj.type
        )
      )

    console.log('GWPLOG:📓 checking add/remove items array')
 
   if ( this.addItems.length === 0 && Object.values(this.removeItems).length === 0) {

      console.log(
        'GWPLOG:📔 empty add: ',
        JSON.parse(JSON.stringify(this.addItems))
      )
      console.log(
        'GWPLOG:📔 empty remove: ',
        JSON.parse(JSON.stringify(this.removeItems))
      )
      console.log('GWPLOG:📔 nothing to update')
      setTimeout(() => {
        const checkoutGwpBtn = document.getElementsByClassName('checkoutForGwp')[0];
        if (checkoutGwpBtn) {
          checkoutGwpBtn.removeAttribute("disabled");
        }
      }, 3000);
      this.loading(false)
    }

    if (Object.values(this.removeItems).length > 0) {
      console.log('GWPLOG:📕 remove products in removeItems array')
      console.log(
        'GWPLOG:📕 remove: ',
        JSON.parse(JSON.stringify(this.removeItems))
      )
      this.cartGWP.removeItems(this.removeItems)
    }

    if (this.addItems.length > 0) {
      console.log('GWPLOG:📗 add products in addItems array')
      console.log('GWPLOG:📗 add: ', JSON.parse(JSON.stringify(this.addItems)))
      this.cartGWP.addItem(this.addItems)
    }

    this.checkGWPEligibilityCounter = 0
  }

  async checkGWPEligibility() {
    console.log('GWPLOG:📓 checking GWP eligibility')
    if (this.checkGWPEligibilityCounter >= 1) return
    this.checkGWPEligibilityCounter = this.checkGWPEligibilityCounter + 1
    console.log(
      `GWPLOG:📓 checkGWPEligibility called ${this.checkGWPEligibilityCounter} time(s)`
    )

    console.log('ran eligability checkssss')

    this.loading(true)

    // Remove gift from cart if GWP type is disabled
    this.gwpTypes
      .filter(obj => !obj.enabled)
      .forEach(disabledObj =>
        this.removeIneligibleGiftsFromCart(disabledObj.type)
      )

    this.checkForDuplicateGifts()

    if (
      window.cartState.items.every(item => item.properties?._giftId) ||
      (window.cartState.items.filter(e => e.handle === 'giftcard').length > 0 &&
        window.cartState.items.some(item => item.properties?._giftId) &&
        window.cartState.items.length <= 3)
    ) {
      console.log(
        'GWPLOG:📕 remove gift product if its the only item in the cart'
      )
      window.cartState.items.forEach(item => {
        if (!item.properties?._giftId) return
        this.cartGWP.removeItems({ [item.key]: 0 })
        // if(window.cartState.items.filter(e => e.handle === "giftcard").length > 0){
        //   return
        // }
        if (!item.properties?._giftId) return
      })
    }
  }

  removeIneligibleGiftsFromCart(gwpType) {
    console.log(
      `GWPLOG:📘 Running removeIneligibleGiftsFromCart(${gwpType})...`
    )
    const gifts = window.cartState.items.filter(
      item => item.properties?._gwpType
    )
 
    const ineligibleGifts = gifts.filter(item =>
      item.properties._gwpType.includes(gwpType)
    )
 
 
    // Remove gifts from disabled GWP types
    if (gifts.some(item => item.properties._gwpType.includes(gwpType))) {
      console.log(`GWPLOG:📕 ${gwpType} gifts aren't enabled `)

      ineligibleGifts.forEach(item => {
        console.log(`GWPLOG:📕 remove ineligible ${gwpType} gift`)
        this.removeItems = { ...this.removeItems, [item.key]: 0 }
      })
    }
  }

  checkForDuplicateGifts() {
    console.log('GWPLOG:📓 checking for duplicate gifts...')
    const items = window.cartState.items
    const giftsWithMultipleQuantities = items.filter(
      item => item.properties?._giftId && item.quantity > 1
    )

    if (items.filter(item => item.properties?._giftId).length < 1) {
      console.log('GWPLOG:📔 no gifts found')
      return
    }

    if (  items.filter(item => item.properties?._gwpType === 'threshold').length ===   1 ) {
      console.log('GWPLOG:📔 no duplicate threshold gifts found')
    }

    // Remove line item duplicates
    if (giftsWithMultipleQuantities.length > 0) {
      giftsWithMultipleQuantities.forEach(item => {
        console.log('GWPLOG:📕 set line item quantity to 1')
        this.removeItems = { ...this.removeItems, [item.key]: 1 }
      })
    }

    // Remove duplicate gift with any purchase
    if (this.enableGWAP) {
      if (
        items.filter(item => item.properties._gwpType === 'auto').length > 1
      ) {
        console.log('GWPLOG:📕 remove duplicate any gift')
        this.removeItems = {
          ...this.removeItems,
          [items.filter(item => item.properties._gwpType === 'auto')[0].key]: 0
        }
      }
    }

    // Remove duplicate threshold gifts
    // if (this.enableGWTP) { 
    //   const thresholdItems = items.filter(item => item.properties._gwpType === 'threshold');
    // console.log('thresholdItems : '+JSON.stringify(thresholdItems))
    //   // Filter items that meet the current threshold
    //   const itemsAtCurrentThreshold = thresholdItems.filter(
    //     item => item.properties._gwpThreshold === this.currentTiers[0]
    //   );
    
    //   if (itemsAtCurrentThreshold.length > 1) {
    //     console.log('GWPLOG:📘 more than one with the same threshold');
    //     console.log('GWPLOG:📘 current threshold is', this.currentTiers[0]);
    //     console.log('GWPLOG:📘 ', itemsAtCurrentThreshold);
    
    //     // Remove duplicates but keep at least one item at the current threshold
    //     itemsAtCurrentThreshold.slice(1).forEach(item => {
    //       this.removeItems = {
    //         ...this.removeItems,
    //         [item.key]: 0
    //       };
    //     });
    //   }
    
    //   console.log("items to remove: " + JSON.stringify(this.removeItems));
    // }
    
   
  }

  gwap(data, type) {
    console.log('GWPLOG:📘 Running GWAP...')
    console.log('GWPLOG:📘 use case 1')
console.log('GWPLOG:📘 use case 1',data)
    if (this.cartState.items.length < 1) return

    let eligibleProductCount = 0
    for (let i = 0; i < this.cartState.items.length; i++) {
      if (
        this.cartState.items[i].handle !== 'giftcard' &&
        !this.cartState.items[i].properties._giftId
      ) {
        eligibleProductCount++
      }
    }

    if (eligibleProductCount < 1) return

    if (
      window.cartState.items.some(
        item => item.properties._gwpType === 'auto'
      ) &&
      this.cartState.items.length === 0
    ) {
      console.log('GWPLOG:📕 removing auto gift')
      this.addGiftToRemoveItems('auto')
    }

    if (
      window.cartState.items.some(item => item.properties._gwpType === 'auto')
    )
      return
    if (window.cartState.items.every(item => item.properties._giftId)) return

    if (data.length > 1) {
      console.log('GWPLOG:📘 more than 1 gift product')
      console.log('GWPLOG:📘 AUTO GIFT')
      // this.triggerGWPModal(type)
    } else {
      console.log('GWPLOG:📘 AUTO GIFT')
      this.addGiftToAddItems(data[0].id, type)
    }
  }

  gwp_product(data, type) {
    
    console.log('GWPLOG:📘 Running GWP Product...');
    let productTargetIds = gwpJSON.productTarget.variants; // Assuming productTarget now holds an array of variants
    let giftTarget = gwpJSON.giftTarget;
    
    // Check if any of the target product variants are in the cart
    let productInCart = this.cartState.items.some(item => productTargetIds.includes(item.id));
    
    if (!productInCart) {
      console.log('GWPLOG:📘 None of the target product variants are in the cart.');

      const giftsInCart = window.cartState.items.filter(
        item => item.properties._gwpType
      )
  
      giftsInCart.forEach(gift => {
        if (gift.properties._gwpType === 'product') 
        {
            this.removeItems = { ...this.removeItems, [gift.key]: 0 }
        }
      }) 
      // this.cartGWP.removeItems(this.removeItems)
      return;
    }
    if (!productInCart) {
      console.log('GWPLOG:📘 The target product is not in the cart.');
     
      return;
    }
    let giftInCart = this.cartState.items.some(item => item.id === giftTarget && item.properties._gwpType === "product" );
    // Check if the gift for the product is already in the cart
    if (giftInCart) {
      console.log('GWPLOG:📘 The gift for the product is already in the cart.');
      return;
    }
    // Add the gift 
    console.log('GWPLOG:📘 Adding the gift for the target product.');
    this.addGiftToAddItems(giftTarget, type); // Use the gift ID defined in the settings
  }

  gwp_collection(data, type) {

    console.log('GWPLOG:📘 Running GWP Collection...');
    
    let collectionTargetIds = gwpJSON.collectionTarget.variants; // Assuming collectionTarget now holds an array of variants
    let giftTarget = gwpJSON.gwcp_gift_product;
    
    // Check if any of the target collection variants are in the cart
    let productInCart = this.cartState.items.some(item => collectionTargetIds.includes(item.id));
    
    if (!productInCart) { 
      console.log('GWPLOG:📘 None of the target collection variants are in the cart.');
      const giftsInCart = window.cartState.items.filter(
        item => item.properties._gwpType
      )
  
      giftsInCart.forEach(gift => {
        if (gift.properties._gwpType === 'collec_prd') 
        {
            this.removeItems = { ...this.removeItems, [gift.key]: 0 }
        }
      })
      // this.cartGWP.removeItems(this.removeItems)
      return;
    }

    let giftInCart = this.cartState.items.some(item => item.id === giftTarget  &&  item.properties._gwpType === "collec_prd");
    // Check if the gift for the collection is already in the cart
    if (giftInCart) {
      console.log('GWPLOG:📘 The gift for the collection is already in the cart.');
      return;
    }

    // Add the gift
    console.log('GWPLOG:📘 Adding the gift for the target collection.');
    this.addGiftToAddItems(giftTarget, type); // Use the gift ID defined in the settings
  }
  async gwtp(data, type) {
    console.log('GWPLOG:📘 Running GWTP...')

    let eligibleProductCount = 0
    let eligibleProductSubtotal = this.price
    for (let i = 0; i < this.cartState.items.length; i++) {
      if (this.cartState.items[i].handle === 'giftcard') {
        eligibleProductSubtotal =
          eligibleProductSubtotal - this.cartState.items[i].price / 100
      } else if (!this.cartState.items[i].properties._giftId) {
        eligibleProductCount++
      }
    }
    console.log("eligibleProductCount : "+eligibleProductCount)

    if (eligibleProductCount < 1) return

    const giftsInTier = Object.values(data).filter(
      gift => this.currentTiers[0] === parseInt(gift.value)
    )
    const modalCookieThreshold =
      parseInt(this.checkCookie(this.gwpDisableModalThreshold)) ||
      this.currentTiers[0]
      if (this.currentTiers.length && this.currentTiers[0] !== modalCookieThreshold) {
        this.disableGWPModalCookies();
      }
    

    console.log('GWPLOG:📓 checking for gifts out of threshold')
    if (
      this.items
        .filter(item => item.properties._gwpType === 'threshold')
        .some(item => item.properties._gwpThreshold != this.currentTiers[0])
    ) {
      console.log('GWPLOG:📘 contains non tier product')
      this.addGiftToRemoveItems('threshold', this.previousTiers[0])
    } else {
      console.log('GWPLOG:📔 nothing to remove')
    }

    if (
      !Object.values(this.sortedGWTPGifts).some(
        gift => this.price >= gift.value
      )
    )
      return
    if (
      window.cartState.items.some(
        item => item.properties._gwpThreshold === this.currentTiers[0]
      )
    )
      return

    console.log('GWPLOG:📘 use case 2')
    console.log('GWPLOG:📘 GIFT AT THRESHOLD')

    if (giftsInTier.length > 1) {
      console.log('GWPLOG:📘 more than 1 gift product')
      giftsInTier.forEach(gift => {
        try {
          this.addGiftToAddItems(gift.id, type, this.currentTiers[0]);
        } catch (error) {
          console.error(`Error adding gift with ID ${gift.id}:`, error);
        }
      });
      // this.triggerGWPModal(giftsInTier[0].type, this.currentTier)
   
    } else {
      console.log('GWPLOG:📘 1 gift product')
      this.addGiftToAddItems(giftsInTier[0].id, type, this.currentTiers[0])
    }
      
  }

  gwcp(data, type) {
    console.log('GWPLOG:📘 Running GWCP...')
    const gwpCollections = gwpJSON.GWPCollections
    const eligibleCollections = []
    const ineligibleCollections = []

    const threshold = gwpJSON.threshold
    const sourceCollection = gwpJSON.sourceCollection

    if (threshold && this.price < threshold) {
      console.log('Threshold NOT MET')
      return this.addGiftToRemoveItems(type, 0, true)
    }
    if (sourceCollection) {
      const doesCartContainItemInSourceCollection = this.items.some(item =>
        sourceCollection.some(i => i === item.variant_id)
      )
      console.log(
        this.items.map(i => i.variant_id),
        sourceCollection
      )
      if (!doesCartContainItemInSourceCollection)
        return this.addGiftToRemoveItems(type, 0, true)
    }

    Object.entries(gwpCollections).forEach(([collectionName, products]) => {
      if (
        products.some(product =>
          this.items.some(
            item =>
              item.handle === product &&
              !Object.keys(item.properties).some(prop => prop === '_giftId')
          )
        )
      ) {
        eligibleCollections.push(collectionName)
      } else {
        ineligibleCollections.push(collectionName)
      }
    })
    console.log(
      'GWPLOG:📘 a line item is in a collection:',
      eligibleCollections.length > 0
    )

    data.forEach(gift => {
      const giftCount = data.filter(obj => obj.value === gift.value).length

      if (
        this.items.some(item =>
          ineligibleCollections.includes(item.properties._gwpCollection)
        )
      ) {
        console.log(
          'GWPLOG:📔 no line items are in these collections:',
          this.items.filter(item =>
            ineligibleCollections.includes(item.properties._gwpCollection)
          )
        )
        if (
          this.items.filter(
            item =>
              item.properties._gwpType === 'collection' &&
              ineligibleCollections.includes(item.properties._gwpCollection)
          )
        ) {
          this.addGiftToRemoveItems(type)
        }
      }

      if (eligibleCollections.includes(gift.value)) {
        console.log(
          'GWPLOG:📘 a line item is in one of these collections:',
          eligibleCollections
        )
        console.log('GWPLOG:📘 use case 3')
        console.log('GWPLOG:📘 COLLECTION GIFT')

        if (
          this.items.filter(
            item => item.properties._gwpCollection === gift.value
          ).length > 1
        ) {
          this.addGiftToRemoveItems(type, gift.value)
        }

        if (
          this.items.some(item => item.properties._gwpCollection === gift.value)
        )
          return

        if (
          !this.items.some(
            item =>
              item.id === gift.id &&
              item.properties._gwpType?.includes('collection')
          )
        ) {
          if (giftCount > 1) {
            console.log('GWPLOG:📘 more than 1 gift product')
          } else {
            console.log('GWPLOG:📘 1 gift product')
          }
        }
      }
    })
  }



  gwtpNotifications() {
    if (!this.enableGWTP) return
    const nextTierProducts = this.sortedGWTPGifts
    .filter(gift => gift.type === 'threshold')
    .filter(gift => this.nextTiers.includes(parseInt(gift.value)));
 

    const gwpUpsellTitle = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__name a'
    )
    const gwpUpsellMainTitle = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__name .product-title--main'
    )
    const gwpUpsellSubTitle = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__name .product-title--sub'
    )
    const gwpUpsellImageWrapper = document.querySelector(
      '.fostr-gwp-upsells .cart-item__media'
    )
    const gwpUpsellIcon = document.querySelector('.fostr-gwp-message-icon')
    let gwpUpsellImage = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__image'
    )
    const gwpUpsellMsg = document.querySelectorAll('[data-gwp-upsell-msg]')
    const gwpUpsellMsgContent = document.querySelector('[data-gwp-upsell-msg]')
      ?.dataset.gwpUpsellMsg
    const gwpUpsellMultipleMsgContent = document.querySelector(
      '[data-gwp-upsell-multiple-msg]'
    )?.dataset.gwpUpsellMultipleMsg

    const gwpUpsellHeadings = document.querySelector(
      '.fostr-gwp-upsells .upsell-headings'
    )

    if (gwpUpsellHeadings) {
      gwpUpsellHeadings.innerText =
        gwpUpsellHeadings.dataset.gwpUpsellHeading.replace(
          '[[ amount ]]',
          window.currencySymbol + this.nextTier
        )
    }

    if (this.nextTier === 0) {
      document
        .querySelectorAll('.fostr-gwp-upsells')
        .forEach(el => el.classList.add('hidden'))
      this.loading(false)
    } else {
      document
        .querySelectorAll('.fostr-gwp-upsells')
        .forEach(el => el.classList.remove('hidden'))

      if (Object.keys(nextTierProducts).length > 1) {
        gwpUpsellMainTitle.forEach(
          el =>
            (el.innerText = gwpUpsellTitle[0].dataset.gwpUpsellMultipleTitle)
        )
        gwpUpsellSubTitle.forEach(el => (el.innerText = ''))
        gwpUpsellMsg.forEach(
          el =>
            (el.innerText = gwpUpsellMultipleMsgContent.replace(
              '[[ amount ]]',
              this.difference
            ))
        )
      } else {
        if(nextTierProducts[0])
        {
          let mainTitle = window.titleize(nextTierProducts[0].title.toLowerCase())

          if (mainTitle.includes('(')) {
            mainTitle = window.titleize(
              nextTierProducts[0].title.split('(')[0].toLowerCase()
            )
            let subTitle = window.titleize(
              nextTierProducts[0].title
                .split('(')
                .reverse()[0]
                .replace(')', '')
                .toLowerCase()
            )

            gwpUpsellSubTitle.forEach(el => (el.innerText = subTitle))
          }

          if (!!gwpUpsellIcon) {
            gwpUpsellImage = document.createElement('img')
            gwpUpsellImage.classList.add('cart-item__image')
            gwpUpsellImageWrapper.append(gwpUpsellImage)
            gwpUpsellImageWrapper
              .querySelector('.fostr-gwp-message-icon')
              .remove()
            gwpUpsellImage.src = nextTierProducts[0].liquidImage
          } else {
            gwpUpsellImage.forEach(
              el => (el.src = nextTierProducts[0].liquidImage)
            )
          }

          gwpUpsellMainTitle.forEach(el => (el.innerText = mainTitle))
          gwpUpsellTitle.forEach(
            el => (el.href = '/products/' + nextTierProducts[0].handle)
          )
          gwpUpsellMsg.forEach(
            el =>
              (el.innerText = gwpUpsellMsgContent.replace(
                '[[ amount ]]',
                this.difference
              ))
          )
        }
      }
    }
  }

  async triggerGWPModal(modalType, currentTier = 0) {
    console.log('GWPLOG:📘 trigger GWP modal')
    const productWrapper = document.querySelectorAll(
      'fostr-menu-carousel-component.fostr-gwp-modal__slider'
    )
    const setSubtitlePrice = document
      .querySelector('.gwtp-modal__subtitle')
      .innerHTML.replace('[[ amount ]]', window.currencySymbol + currentTier)
    const setCollectionName = document
      .querySelector('.gwcp-modal__subtitle')
      .innerHTML.replace('[[ collection ]]', currentTier)
    const gwpTypes = ['threshold', 'collection']

    let modal = document.querySelector('.gwp-modal')

    if (!modal) return
    modal.dataset.gwpType = modalType

    let modalSubTitle = modal.querySelector('.gwtp-modal__subtitle')
    if (modalSubTitle) {
      modalSubTitle.innerText = setSubtitlePrice
    }

    modalSubTitle = modal.querySelector('.gwcp-modal__subtitle')
    if (modalSubTitle) {
      modalSubTitle.innerText = setCollectionName
    }

    if (modalType === 'threshold') {
      modalSubTitle.classList.remove('hidden')
    }

    if (modalType === 'collection') {
      document.querySelector('.gwcp-modal__subtitle').classList.remove('hidden')
    }

    productWrapper.forEach(item => (item.style.display = 'none'))

    if (modalType === 'auto') {
      document
        .querySelectorAll('[data-gwp-auto]')
        .forEach(
          item =>
            (item.closest('.fostr-gwp-modal__slider').style.display = 'block')
        )
    } 

    gwpTypes.forEach(type => {
      if (modalType === type) {
        document
          .querySelectorAll(`[data-gwp-${type}="${currentTier}"]`)
          .forEach(
            item =>
              (item.closest('.fostr-gwp-modal__slider').style.display = 'block')
          )
      }
    })

    document.body.classList.add('overflow-hidden')
    let modalGwp = document.getElementById('ProductModal-GWP')
    if (modalGwp) {
      document.getElementById('ProductModal-GWP').setAttribute('open', '')
    }
  }
  async addGiftToAddItems(variantId, type, value = null) {
    let giftVariantId = parseInt(variantId)
    if (!giftVariantId) return
    if (this.addItems.some(item => item.id === giftVariantId)) return
    console.log('GWPLOG:📘 add GWP')
    const giftId = Math.floor(Math.random() * 1000000 + 1000)
 
    this.addItems.push({
      id: giftVariantId,
      quantity: 1,
      properties: {
        ...(!!value && { [`_gwp${window.capitalize(type)}`]: value }),
        _gwpType: type,
        _giftId: giftId
      }
    })
    
  }

 
   

  


  async isInAddArr( id, value, type)
  {
      console.log("📕 📕 ",id);
      console.log("Checking items in window.gwpJSON:", gwpJSON);
      for (const key in gwpJSON.GWPGifts) {
        if (gwpJSON.GWPGifts.hasOwnProperty(key)) {
            const item = gwpJSON.GWPGifts[key];
            if (item.id === id && item.value === value && item.type === type) {
              console.log("-------------------" ,item);
            }
        }
    }
    return null; 
  }
  async addGiftToRemoveItems(type, currentVal = 0, thold = false) {
    const giftsInCart = window.cartState.items.filter(
      item => item.properties._gwpType
    )
    let giftVariantId

    giftsInCart.forEach(gift => {
    if (gift.properties._gwpType === 'threshold') 
      {

            if (gift.properties[`_gwp${capitalize(type)}`] !== this.currentTiers[0]) {
              if( this.isInAddArr(gift.id,this.currentTiers[0],"threshold") != null)
              {
                   giftVariantId = gift.key;
                   this.isInAddArr(gift.id,this.currentTiers[0],"threshold")
              }
           
            }

            if (giftVariantId === undefined) return

            console.log(
              `GWPLOG:📕 removing ${type} gift`,
              gift.properties[`_gwp${capitalize(type)}`]
            )
            console.log('GWPLOG:📕 line item key to remove:', giftVariantId)
            this.removeItems = { ...this.removeItems, [giftVariantId]: 0 }
        
      }

      if (gift.properties._gwpType === 'collection') {
        if (!thold) {
          if (gift.properties[`_gwp${capitalize(type)}`] === currentVal) {
            giftVariantId = gift.key
          }

          if (giftVariantId === undefined) return

          console.log(
            `GWPLOG:📕 removing ${type} gift`,
            gift.properties[`_gwp${capitalize(type)}`]
          )
        } else {
          giftVariantId = gift.variant_id
        }
        console.log('GWPLOG:📕 line item key to remove:', giftVariantId)
        this.removeItems = { ...this.removeItems, [giftVariantId]: 0 }
      }
       
    })
  }

  checkCookie(param) {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=')
      return parts[0] === param ? decodeURIComponent(parts[1]) : r
    }, '')
  }

  disableGWPModalCookies() {
    const expires = 'Thu, 01 Jan 1970 00:00:00 UTC'
    document.cookie =
      this.gwpDisableModalCookie + '=;expires=' + expires + '; path=/'
    document.cookie =
      this.gwpDisableModalThreshold + '=;expires=' + expires + '; path=/'
    document.cookie =
      this.gwpModalCloseCounterCookie + '=;expires=' + expires + '; path=/'
    document
      .querySelectorAll('.gwp-modal-disabled')
      .forEach(el => el.classList.add('hidden'))
    this.checkGWPEligibility()
  }

  closeModalCounter(threshold) {
    const expires = new Date(Date.now() + 1 * 864e5).toUTCString()
    const getGWPCounterValue = this.checkCookie(this.gwpModalCloseCounterCookie)

    this.gwpModalCloseCounter = getGWPCounterValue
      ? parseInt(getGWPCounterValue) + 1
      : this.gwpModalCloseCounter + 1

    document.cookie =
      this.gwpModalCloseCounterCookie +
      '=' +
      encodeURIComponent(this.gwpModalCloseCounter) +
      ';expires=' +
      expires +
      '; path=/'

    if (this.gwpModalCloseCounter >= 2) {
      document.cookie =
        this.gwpDisableModalCookie + '=true;expires=' + expires + '; path=/'
      document.cookie =
        this.gwpDisableModalThreshold +
        '=' +
        threshold +
        ';expires=' +
        expires +
        '; path=/'
      document
        .querySelectorAll('.gwp-modal-disabled')
        .forEach(el => el.classList.remove('hidden'))
    }
  }
}

customElements.define('fostr-gwp', FostrGWP)

class FostrCartGWP extends FostrCartDrawer {
  constructor() {
    super({
      name: 'Fostr Cart GWP',
      version: '1.0.0'
    })

    this.gwp = document.querySelector('fostr-gwp')
    this.sectionsToRender = []
  }

  // getSectionsToRender() {
  //   return this.sectionsToRender;
  // }

  addItem(items) {
    this.sectionsToRender = [
      {
        id: 'fostr-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'fostr-cart-icon-bubble'
      }
    ]

    if (!items) {
      console.error('variant_id is required')
      setTimeout(() => {
        const checkoutGwpBtn = document.getElementsByClassName('checkoutForGwp')[0];
        if (checkoutGwpBtn) {
          checkoutGwpBtn.removeAttribute("disabled");
        }
      }, 3000);
      return Promise.resolve(false)
    } 
    const body = JSON.stringify({
      items: items,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    })

    return fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body
    })
      .then(response => response.json())
      .then(parsedState => {
        this.renderContents(parsedState, true)
        this.disableLoading()

        console.log('GWPLOG:📗 ADD ITEMS: ', this.gwp.addItems)
        this.gwp.loading(false)
        this.gwp.addItems = []
        document
          .querySelectorAll('[data-gwtp-message]')
          .forEach(
            el =>
              (el.innerText = el.dataset.gwtpMessage.replace(
                '[[ amount ]]',
                window.currencySymbol + el.dataset.gwtpThreshold
              ))
          )

        const minicartMessagingWrapper = document.querySelector(
          '.minicart-messaging-wrapper'
        )

        // if (minicartMessagingWrapper.childNodes.length < 1) {
        //   const minicartMessaging = document.createElement('div')

        //   minicartMessaging.classList.add('minicart-messaging', 'fade-in')
        //   minicartMessaging.innerText = gwpJSON.GWPMinicartNotification
        //   minicartMessagingWrapper.append(minicartMessaging)

        //   window.setTimeout(() => {
        //     minicartMessaging.classList.remove('fade-in')
        //     minicartMessaging.classList.add('fade-out')

        //     minicartMessaging.addEventListener('animationend', () => {
        //       minicartMessaging.remove()
        //     })
        //   }, 3000)
        // }
        setTimeout(() => {
          const checkoutGwpBtn = document.getElementsByClassName('checkoutForGwp')[0];
          if (checkoutGwpBtn) {
            checkoutGwpBtn.removeAttribute("disabled");
          }
        }, 3000);
        return parsedState
      })
      .catch(err => {
        // this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        console.error(err)
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
          setTimeout(() => {
            const checkoutGwpBtn = document.getElementsByClassName('checkoutForGwp')[0];
            if (checkoutGwpBtn) {
              checkoutGwpBtn.removeAttribute("disabled");
            }
          }, 3000);
        this.disableLoading()
      })
  }

  removeItems(items) {
    this.sectionsToRender = [
      {
        id: 'fostr-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'fostr-cart-icon-bubble'
      }
    ]

    const body = JSON.stringify({
      updates: items,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    })

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.json())
      .then(parsedState => {
        this.renderContents(parsedState, true)
        this.disableLoading()
        console.log('GWPLOG:📕 REMOVE ITEMS: ', this.gwp.removeItems)
        console.log('removing items ',items)
        this.gwp.loading(false)
        this.gwp.removeItems = {};
        setTimeout(() => {
          const checkoutGwpBtn = document.getElementsByClassName('checkoutForGwp')[0];
          if (checkoutGwpBtn) {
            checkoutGwpBtn.removeAttribute("disabled");
          }
        }, 3000);
        return parsedState
        
      })
      .catch(err => {
        // this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        console.error(err)
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
          setTimeout(() => {
            const checkoutGwpBtn = document.getElementsByClassName('checkoutForGwp')[0];
            if (checkoutGwpBtn) {
              checkoutGwpBtn.removeAttribute("disabled");
            }
          }, 3000);
        this.disableLoading()
      })
  }
}

customElements.define('fostr-cart-gwp', FostrCartGWP)

if (customElements.get('quick-buy')) {
  class QuickBuyGWP extends QuickBuy {
    constructor() {
      super()

      this.gwp = document.querySelector('fostr-gwp')
    }

    onClickHandler(event) {
      this.gwp.checkGWPEligibilityCounter = 0

      if (event.target.dataset.quickBuyFunction.length >= 1) {
        let altMethod = JSON.parse(event.target.dataset.quickBuyFunction)

        altMethod.forEach(method => {
          const gwpType = event.target.closest('gwp-modal').dataset.gwpType
          const giftId = event.target
            .closest('quick-buy-gwp')
            .getAttribute('variant-ids')

          if (gwpType === 'auto') {
            document
              .querySelector(method.component)
              [method.method](giftId, gwpType)
          } else if (gwpType === 'threshold') {
            document
              .querySelector(method.component)
              [method.method](
                giftId,
                gwpType,
                parseInt(
                  event.target.closest('fostr-menu-slide-component').dataset
                    .gwpThreshold
                )
              )
          } else if (gwpType === 'collection') {
            document
              .querySelector(method.component)
              [method.method](
                giftId,
                gwpType,
                event.target.closest('fostr-menu-slide-component').dataset
                  .gwpCollection
              )
          }
        })
      }

      document.body.classList.remove('overflow-hidden')
      document.getElementById('ProductModal-GWP').removeAttribute('open')
    }
  }

  customElements.define('quick-buy-gwp', QuickBuyGWP)
}

if (customElements.get('modal-dialog')) {
  class GWPModal extends ModalDialog {
    constructor() {
      super()
    }
  }
  customElements.define('gwp-modal', GWPModal)
}
